angular.module 'zc.commonApi'

.factory 'ReportRange', (cronHours, Project) ->

  class ReportRange
    @isLatest: (begin_at) ->
      moment(begin_at).tz(Project.getRegion()).isSame(baseTime(), 'month')

    @hasLatest: ->
      baseTime().date() > 1

    @getLatest: ->
      _baseTime = baseTime()
      begin_at: moment(_baseTime).startOf('month').toDate()
      start_at: moment(_baseTime).subtract(1, 'days').startOf('day').toDate()
      end_at: moment(_baseTime).startOf('day').toDate()

    baseTime = ->
      moment().tz(Project.getRegion()).subtract(cronHours.dailyReport, 'hours')



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/misc/report_range.service.coffee